import * as actions from './actionsTypes';

const initialData = {
  loading: false,
  saveLoader: false,
  checklistEmp: [],
  // checklistEmpLength: 0,
}

export default function employeeDocsCheckListReducer(state = initialData, action){
  switch (action.type) {
    case actions.LOADING_EMP_CHECKLIST:
      return {...state, loading: action.payload}
    case actions.GET_EMP_CHECKLIST:
      return {...state, checklistEmp: action.payload}
    case actions.SAVE_LOADER_EMP_CHECKLIST:
      return{...state, saveLoader: action.payload
        // , checklistEmpLength: action.payload.checklistEmpLength 
      }
    default:
      return state
  }
}